// contexts/ValidationContext.tsx

import { createContext, useContext } from "react";
import { ValidationResult } from "../providers/ValidationProvider";
import { AllDataSources } from "../utils/dataMappers";

// Tentukan bentuk (shape) dari data yang akan Anda bagikan
interface ValidationContextState {
  requiredList: ValidationResult[]; // Ganti `any` dengan tipe yang sesuai
  unrequiredList: ValidationResult[];
  validationResults: Record<
    string,
    { isValid: boolean | null; isValidateNow: boolean | null }
  >;
  overallStatus:
    | "Unvalidated"
    | "Validated"
    | "Partially Validated"
    | "Validation Bypassed"
    | "Optional"
    | "Loading";
  isLoading: boolean;
  getStatusForSubmit?: (overrideDataSources: Partial<AllDataSources>) => {
    requiredList: ValidationResult[];
    unrequiredList: ValidationResult[];
    validationResults: Record<
      string,
      { isValid: boolean | null; isValidateNow: boolean | null }
    >;
    overallStatus: ValidationContextState["overallStatus"];
  };
}

// Buat Context dengan nilai default
export const ValidationContext = createContext<
  ValidationContextState | undefined
>(undefined);

// Buat custom hook untuk mempermudah penggunaan Context
export function useValidation() {
  const context = useContext(ValidationContext);
  if (context === undefined) {
    throw new Error("useValidation must be used within a ValidationProvider");
  }
  return context;
}
